package sarka.design.skoria.ui.composables

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.layout.onGloballyPositioned
import kotlinx.browser.document
import kotlinx.browser.window
import org.w3c.dom.HTMLDivElement
import org.w3c.dom.HTMLElement
import org.w3c.dom.ShadowRoot

private fun composeShadowRoot(): ShadowRoot? =
    (document.body as? HTMLElement)
        ?.asDynamic()
        ?.shadowRoot
        ?.unsafeCast<ShadowRoot?>()

@Composable
actual fun SkoriaRerollText() {
    val overlayDiv = remember {
        (document.createElement("div") as HTMLDivElement).apply {
            style.position = "absolute"
            style.zIndex = "10000"
            style.display = "flex"
            style.setProperty("align-items", "center")
            style.setProperty("gap", "4px")
            style.setProperty("pointer-events", "none")
            innerHTML = """
                <svg width="20" height="20" viewBox="0 0 400 400" xmlns="http://www.w3.org/2000/svg">
                  <path d="M291.3,106.2l-28.5,-47.6l-62.8,-45.5l-62.8,45.5l-73.2,122.4l1.4,44.9l1.9,61.5l55.7,87.9l77,11.6l77,-11.6l55.7,-87.9l3.3,-106.4z" fill="#00A14B"/>
                  <path d="M209,266.2l-86,109.1l-55.7,-87.9l-1.9,-61.5z" fill="#2E8B57"/>
                  <path d="M332.7,287.4l-55.7,87.9l-77,11.6l-77,-11.6l86,-109.1l35.9,-61.6z" fill="#3A7D4F"/>
                  <path d="M244.9,204.6l-35.9,61.6l-143.6,-40.3l-1.4,-44.9l115.4,-38z" fill="#1D9141"/>
                  <path d="M336,181l-3.3,106.4l-87.8,-82.8l-65.5,-61.6l111.9,-36.8z" fill="#28854A"/>
                  <path d="M291.3,106.2l-111.9,36.8l20.6,-129.9l62.8,45.5z" fill="#0FAD52"/>
                  <path d="M200,13.1l-20.6,129.9l-115.4,38l73.2,-122.4z" fill="#07A34B"/>
                </svg>
                <span style="color:#00A14B;font-family:sans-serif;">Skoria Reroll</span>
            """.trimIndent()
        }
    }

    DisposableEffect(Unit) {
        val sr = composeShadowRoot()
        val wrapper = sr?.querySelector("div")?.unsafeCast<HTMLElement>()
        val parent = wrapper ?: sr?.unsafeCast<HTMLElement?>()

        if (parent != null) {
            if (parent.style.position.isNullOrBlank()) parent.style.position = "relative"
            parent.appendChild(overlayDiv)
        }

        onDispose {
            overlayDiv.parentElement?.removeChild(overlayDiv)
        }
    }

    Box(
        modifier = Modifier
            .fillMaxSize()
            .onGloballyPositioned { coordinates ->
                val dpr = window.devicePixelRatio.takeIf { it > 0 } ?: 1.0

                val posDevice = coordinates.localToWindow(Offset.Zero)
                val posCssX = posDevice.x / dpr
                val posCssY = posDevice.y / dpr

                val heightCss = coordinates.size.height / dpr

                val sr = composeShadowRoot()
                val wrapper = sr?.querySelector("div")?.unsafeCast<HTMLElement>()
                val parent = wrapper ?: sr?.unsafeCast<HTMLElement?>() ?: return@onGloballyPositioned
                val rect = parent.getBoundingClientRect()

                val left = posCssX - rect.left
                val top = posCssY - rect.top

                // Position at bottom-left of the Box
                overlayDiv.style.left = "${left + 8}px"
                overlayDiv.style.top = "${top + heightCss - 28}px"
            }
    )
}
